import { useAuth, useTranslation } from '@/context/AuthContext';
import { useState, useEffect } from 'react';
import { getTrips } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Wallet } from 'lucide-react';

export default function Budget() {
  const { families } = useAuth();
  const { t } = useTranslation();
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (families.length > 0) {
      getTrips(families[0].family_id).then(r => setTrips(r.data)).catch(() => {}).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [families]);

  if (loading) return <div className="h-48 bg-[#E2E8F0] rounded-2xl animate-pulse" />;

  return (
    <div className="space-y-6 animate-fade-in" data-testid="budget-page">
      <h1 className="text-2xl md:text-3xl text-[#1E293B]" >
        {t('budget.title')}
      </h1>

      {trips.length === 0 ? (
        <Card className="border border-[#E2E8F0]/40 rounded-2xl">
          <CardContent className="p-12 text-center">
            <Wallet className="w-12 h-12 text-[#E2E8F0] mx-auto mb-4" strokeWidth={1} />
            <p className="text-sm text-[#64748B]">{t('common.noData')}</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-4">
          <p className="text-sm text-[#64748B]">
            {t('budget.title')} — {families[0]?.name}
          </p>
          {trips.map(trip => (
            <Card key={trip.trip_id} className="border border-[#E2E8F0]/40 rounded-2xl" data-testid={`budget-trip-${trip.trip_id}`}>
              <CardContent className="p-5">
                <h3 className="font-medium text-[#1E293B] mb-3" >{trip.name}</h3>
                <p className="text-xs text-[#64748B] mb-2">{trip.destination} · {trip.currency}</p>
                <div className="text-sm text-[#64748B]">
                  {t('trips.bookings')}: {trip.bookings_count || 0} · {t('tasks.title')}: {trip.tasks_done || 0}/{trip.tasks_total || 0}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
